import { render, staticRenderFns } from "./notEffectiveSource.vue?vue&type=template&id=221d2014&"
import script from "./notEffectiveSource.vue?vue&type=script&lang=js&"
export * from "./notEffectiveSource.vue?vue&type=script&lang=js&"
import style0 from "./notEffectiveSource.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports